module.exports = __webpack_public_path__ + "img/timbre_img.9b4ffdb7.png";